// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DGI2","colBig":"styles_colBig__2pBjY","colSmall":"styles_colSmall__DRNpK","shopifyNameWrapper":"styles_shopifyNameWrapper__1vt6I"};